import { Component, OnInit } from '@angular/core';
import { EnterpriseService } from '../enterprise.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-enterprise-api-content',
  templateUrl: './api-content.component.html',
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
})
export class EnterpriseApiContentComponent implements OnInit {
  apiContentData:any;
  queryParams: any;
  constructor(
    private enterpriseService: EnterpriseService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router
  ) {
    this.getUrl = this.router.url;
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    let data = this.route.snapshot.data?.['seo']?.[0].fields;
    this.apiContentData = data?.apiContentPanel?.fields;
  }
}
